function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import '../BasicMapModulePlugin';
import './event/DataForMapLocationEvent';
import './formatter/GetFeatureInfoFormatter';
import './request/GetFeatureInfoHandler';
import './request/GetFeatureInfoRequest';
import './request/GetFeatureInfoActivationRequest';
import './request/ResultHandlerRequest';
import './request/ResultHandlerRequestHandler';
import './request/SwipeStatusRequest';
import './request/SwipeStatusRequestHandler';
import { getGfiContent, getGfiResponseType, hasGfiData } from './GfiHelper';
var GFI_TYPE_APPLICATION_JSON = 'application/json';
/**
 * @class Oskari.mapframework.mapmodule.GetInfoPlugin
 *
 * Listens to map clicks and requests server for information about the map
 * location for all
 * the layers that have the flag queryable set to true and layer scales matching
 * the current zoom level.
 * Handles MapModulePlugin.GetFeatureInfoRequest and
 * MapModulePlugin.GetFeatureInfoActivationRequest.
 *
 * See
 * http://www.oskari.org/trac/wiki/DocumentationBundleMapModulePluginGetInfoPlugin
 */
Oskari.clazz.define('Oskari.mapframework.mapmodule.GetInfoPlugin',
/**
 * @static @method create called automatically on construction
 *
 *
 */
function () {
  var me = this;
  me._clazz = 'Oskari.mapframework.mapmodule.GetInfoPlugin';
  me._name = 'GetInfoPlugin';
  me.infoboxId = 'getinforesult';
  me._pendingAjaxQuery = {
    busy: false,
    jqhr: null,
    timestamp: null
  };
  me._location = null;

  /* templates (from formatter/GetFeatureInfoFormatter.js) */
  me.template = {};
  var p;
  for (p in me.__templates) {
    if (me.__templates.hasOwnProperty(p)) {
      me.template[p] = jQuery(me.__templates[p]);
    }
  }
  this._requestedDisabled = new Set(); // ids that requested plugin to be disabled
  this._swipeStatus = {
    cropX: null,
    layerId: null
  };
}, {
  /**
   * @private @method _initImpl
   *
   * Interface method for the module protocol
   *
   *
   */
  _initImpl: function _initImpl() {
    Oskari.log('GetInfoPlugin').debug('init');
    var wfsPlugin = this.getMapModule().getLayerPlugins('wfs');
    if (wfsPlugin && !!wfsPlugin.isRenderModeSupported) {
      // Using wfs vector plugin
      this._ignoreUserLayers();
    }
  },
  _ignoreUserLayers: function _ignoreUserLayers() {
    this._config = this._config || {};
    var ignoredLayerTypes = new Set(this._config.ignoredLayerTypes || []);
    ignoredLayerTypes.add('WFS');
    ignoredLayerTypes.add('MYPLACES');
    ignoredLayerTypes.add('USERLAYER');
    this._config.ignoredLayerTypes = Array.from(ignoredLayerTypes);
  },
  // @override
  setEnabled: function setEnabled(enabled, id) {
    var ids = this._requestedDisabled;
    // if request has id, store/remove it
    if (id) {
      if (enabled) {
        ids.delete(id);
      } else {
        ids.add(id);
      }
    }
    if (enabled && ids.size > 0) {
      Oskari.log('GetInfoPlugin').debug('Skipping enable plugin!! Plugin is disabled by: ' + Array.from(ids).join());
      return;
    }
    // toggle controls
    if (!enabled) {
      this._closeGfiInfo();
    }
    this._enabled = enabled;
  },
  _stopPluginImpl: function _stopPluginImpl() {
    // hide infobox if open
    this._closeGfiInfo();
  },
  setLocation: function setLocation(lonlat) {
    this._location = lonlat;
  },
  getLocation: function getLocation() {
    return this._location;
  },
  resetLocation: function resetLocation() {
    this._location = null;
  },
  _createEventHandlers: function _createEventHandlers() {
    return {
      EscPressedEvent: function EscPressedEvent(evt) {
        this._closeGfiInfo();
      },
      MapClickedEvent: function MapClickedEvent(evt) {
        if (!this.isEnabled()) {
          // disabled, do nothing
          return;
        }
        var click = evt.getLonLat();
        var lonlat = this.getLocation();
        // remove old popup
        if (!lonlat || lonlat.lon !== click.lon || lonlat.lat !== click.lat) {
          this._closeGfiInfo();
        }
        this.handleGetInfo(click);
      },
      AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent(evt) {
        this._refreshGfiInfo('remove', evt.getMapLayer().getId());
      },
      AfterMapLayerAddEvent: function AfterMapLayerAddEvent(evt) {
        this._refreshGfiInfo();
      },
      'InfoBox.InfoBoxEvent': function InfoBoxInfoBoxEvent(evt) {
        this._handleInfoBoxEvent(evt);
      },
      GetInfoResultEvent: function GetInfoResultEvent(evt) {
        if (this.isEnabled()) {
          this._handleInfoResult(evt.getData());
        }
      },
      'Realtime.RefreshLayerEvent': function RealtimeRefreshLayerEvent(evt) {
        this._refreshGfiInfo('update', evt.getMapLayer().getId());
      },
      'Publisher2.ColourSchemeChangedEvent': function Publisher2ColourSchemeChangedEvent(evt) {
        this._handleColourSchemeChangedEvent(evt);
      }
    };
  },
  _handleColourSchemeChangedEvent: function _handleColourSchemeChangedEvent(evt) {
    if (this._config) {
      this._config.colourScheme = evt.getColourScheme();
    } else {
      this._config = {
        colourScheme: evt.getColourScheme()
      };
    }
  },
  _createRequestHandlers: function _createRequestHandlers() {
    var handler = Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.getinfo.GetFeatureInfoHandler', this);
    return {
      'MapModulePlugin.GetFeatureInfoRequest': handler,
      'MapModulePlugin.GetFeatureInfoActivationRequest': handler,
      'GetInfoPlugin.ResultHandlerRequest': Oskari.clazz.create('Oskari.mapframework.mapmodule.getinfoplugin.request.ResultHandlerRequestHandler', this),
      'GetInfoPlugin.SwipeStatusRequest': Oskari.clazz.create('Oskari.mapframework.mapmodule.getinfoplugin.request.SwipeStatusRequestHandler', this)
    };
  },
  resetUI: function resetUI() {
    this._closeGfiInfo();
  },
  /**
   * @method _cancelAjaxRequest
   * @private
   * Cancels any GetInfo ajax request that might be executing.
   */
  _cancelAjaxRequest: function _cancelAjaxRequest() {
    var me = this;
    if (!me._pendingAjaxQuery.busy) {
      return;
    }
    var jqhr = me._pendingAjaxQuery.jqhr;
    me._pendingAjaxQuery.jqhr = null;
    if (!jqhr) {
      return;
    }
    Oskari.log('GetInfoPlugin').debug('Abort jqhr ajax request');
    jqhr.abort();
    jqhr = null;
    me._pendingAjaxQuery.busy = false;
  },
  /**
   * Constructs a layer list for valid layers for info queries
   *
   * @method _buildLayerIdList
   * @private
   * @param {Oskari.Layer[]} layers to build the list from (optional)
   * @return {Number[] | String[]} array of qualified layer ids.
   */
  _buildLayerIdList: function _buildLayerIdList() {
    var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var me = this;
    var layerIds = layers.filter(function (layer) {
      return me._isQualified(layer);
    }).map(function (layer) {
      return layer.getId();
    });
    return layerIds || [];
  },
  _isQualified: function _isQualified(layer) {
    return !this._isIgnoredLayerType(layer) && layer.getQueryable && layer.getQueryable() && layer.isInScale(this.getSandbox().getMap().getScale()) && layer.isVisible() && layer.getOpacity() !== 0;
  },
  /**
   * Checks if layer's type is ignored
   *
   * @method _isIgnoredLayerType
   * @private
   * @param {Oskari.mapframework.domain.AbstractLayer} layer
   * @return {Boolean} true if layer's type is ignored
   */
  _isIgnoredLayerType: function _isIgnoredLayerType(layer) {
    var ignored = (this._config || {}).ignoredLayerTypes;
    if (!Array.isArray(ignored)) {
      return false;
    }
    return ignored.some(function (type) {
      return layer.isLayerOfType(type);
    });
  },
  /**
   * @method _startAjaxRequest
   * @private
   * Sets internal flags to show that an ajax request is executing currently.
   * @param {Number} dteMs current time in milliseconds
   */
  _startAjaxRequest: function _startAjaxRequest(dteMs) {
    this._pendingAjaxQuery.busy = true;
    this._pendingAjaxQuery.timestamp = dteMs;
  },
  /**
   * @method _finishAjaxRequest
   * @private
   * Clears internal flags of executing ajax requests so we are clear to start
   * another.
   */
  _finishAjaxRequest: function _finishAjaxRequest() {
    this._pendingAjaxQuery.busy = false;
    this._pendingAjaxQuery.jqhr = null;
    Oskari.log('GetInfoPlugin').debug('Finished jqhr ajax request');
  },
  /**
   * @method _notifyAjaxFailure
   * @private
   * Prints debug about ajax call failure.
   */
  _notifyAjaxFailure: function _notifyAjaxFailure() {
    Oskari.log('GetInfoPlugin').debug('GetFeatureInfo AJAX failed');
  },
  /**
   * @method _isAjaxRequestBusy
   * @private
   * Checks internal flags if and ajax requests is currently executing.
   * @return {Boolean} true if an ajax request is executing currently
   */
  _isAjaxRequestBusy: function _isAjaxRequestBusy() {
    return this._pendingAjaxQuery.busy;
  },
  /**
   * @method getFeatureInfoUrl
   * Get URL using openlayers getFeatureInfoUrl
   * This handles x and y correctly when the map is rotated etc
   * @param {Object} coordinates to query
   * @returns {String} url for GFI queries
   */
  _getFeatureInfoUrl: function _getFeatureInfoUrl(coordinate) {
    var projection = this.getMapModule().getProjection();
    var resolution = this.getMapModule().getResolution();
    var _iterator = _createForOfIteratorHelper(this.getSandbox().getMap().getLayers()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var layer = _step.value;
        var _iterator2 = _createForOfIteratorHelper(this.getMapModule().getOLMapLayers(layer.getId())),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var olLayer = _step2.value;
            if (olLayer.getSource()['getFeatureInfoUrl'] !== undefined) {
              return olLayer.getSource().getFeatureInfoUrl([coordinate.lon, coordinate.lat], resolution, projection);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  /**
   * @method handleGetInfo
   * Send ajax request to get feature info for given location for any
   * visible/valid/queryable layers.
   * Backend processes given layer (ids) as WMS GetFeatureInfo or WFS requests
   * (or in the future WMTS GetFeatureInfo). Aborts any pending ajax query.
   *
   * @param {OpenLayers.LonLat}
   *            lonlat coordinates
   */
  handleGetInfo: function handleGetInfo(lonlat, layers) {
    var _this = this;
    var me = this;
    var dteMs = new Date().getTime();
    var requestedLayers = layers || me.getSandbox().findAllSelectedMapLayers();
    var layerIds = me._buildLayerIdList(requestedLayers);
    var mapVO = me.getSandbox().getMap();
    var px = me.getMapModule().getPixelFromCoordinate(lonlat);
    if (this._swipeStatus.layerId && px.x > this._swipeStatus.cropX) {
      layerIds = layerIds.filter(function (l) {
        return l !== _this._swipeStatus.layerId;
      });
    }
    if (layerIds.length === 0) {
      return;
    }
    var additionalParams = requestedLayers.filter(function (layer) {
      return layerIds.includes(layer.getId());
    }).reduce(function (result, layer) {
      var params = layer.getParams();
      if (_typeof(params) !== 'object') {
        return result;
      }
      result[layer.getId()] = _objectSpread(_objectSpread({}, params), {}, {
        STYLES: layer.getCurrentStyle().getName()
      });
      return result;
    }, {});
    if (me._pendingAjaxQuery.busy && me._pendingAjaxQuery.timestamp && dteMs - me._pendingAjaxQuery.timestamp < 500) {
      Oskari.log('GetInfoPlugin').debug('GetFeatureInfo NOT SENT (time difference < 500ms)');
      return;
    }
    me._cancelAjaxRequest();
    me._startAjaxRequest(dteMs);
    var featureInfoUrl = this._getFeatureInfoUrl(lonlat);
    var x = Math.round(px.x);
    var y = Math.round(px.y);
    var width = mapVO.getWidth();
    var height = mapVO.getHeight();
    var bbox = mapVO.getBboxAsString();
    if (featureInfoUrl) {
      if (featureInfoUrl.startsWith('/')) {
        // fixes urls starting with /action or one without protocol in general //somedomain.com
        // we don't really care about the domain, we are only interested in getting parts of the querystring
        featureInfoUrl = 'https://' + window.location.hostname + featureInfoUrl;
      }
      var url = new URL(featureInfoUrl);
      if (url.searchParams.get('I')) {
        x = Number.parseInt(url.searchParams.get('I'), 10);
      } else if (url.searchParams.get('X')) {
        x = Number.parseInt(url.searchParams.get('X'), 10);
      }
      if (url.searchParams.get('J')) {
        y = Number.parseInt(url.searchParams.get('J'), 10);
      } else if (url.searchParams.get('Y')) {
        y = Number.parseInt(url.searchParams.get('Y'), 10);
      }
      width = Number.parseInt(url.searchParams.get('WIDTH'), 10);
      height = Number.parseInt(url.searchParams.get('HEIGHT'), 10);
      bbox = url.searchParams.get('BBOX');
    }
    var payload = {
      layerIds: layerIds.join(','),
      projection: me.getMapModule().getProjection(),
      x: x,
      y: y,
      lon: lonlat.lon,
      lat: lonlat.lat,
      width: width,
      height: height,
      bbox: bbox,
      zoom: mapVO.getZoom(),
      srs: mapVO.getSrsName(),
      params: JSON.stringify(additionalParams)
    };
    jQuery.ajax({
      beforeSend: function beforeSend(x) {
        // save ref to pending request
        me._pendingAjaxQuery.jqhr = x;
        if (x && x.overrideMimeType) {
          x.overrideMimeType('application/json;charset=UTF-8');
        }
      },
      success: function success(resp) {
        if (me._isAjaxRequestBusy()) {
          var data = resp.data || [];
          data.forEach(function (datum) {
            var gfiType = (datum === null || datum === void 0 ? void 0 : datum.gfiType) || null;
            var features = [datum];
            if (gfiType === GFI_TYPE_APPLICATION_JSON && !me.hasCustomFormatter(datum)) {
              var _geoJSON$features;
              var geoJSON = JSON.parse(datum === null || datum === void 0 ? void 0 : datum.content);
              features = (geoJSON === null || geoJSON === void 0 || (_geoJSON$features = geoJSON.features) === null || _geoJSON$features === void 0 ? void 0 : _geoJSON$features.map(function (feature) {
                return feature.properties;
              })) || null;
            }
            me._handleInfoResult({
              layerId: datum.layerId,
              features: features,
              lonlat: lonlat,
              gfiType: gfiType,
              via: 'ajax'
            });
          });
        }
        me._finishAjaxRequest();
      },
      error: function error() {
        me._finishAjaxRequest();
        me._notifyAjaxFailure();
      },
      always: function always() {
        me._finishAjaxRequest();
      },
      complete: function complete() {
        me._finishAjaxRequest();
      },
      data: _objectSpread({}, payload),
      type: 'POST',
      dataType: 'json',
      url: Oskari.urls.getRoute('GetFeatureInfoWMS')
    });
  },
  addInfoResultHandler: function addInfoResultHandler(callback) {
    this._showGfiInfo = callback;
  },
  setSwipeStatus: function setSwipeStatus(layerId, cropX) {
    this._swipeStatus = {
      layerId: layerId,
      cropX: cropX
    };
  },
  /**
   * Sends DataForMapLocationEvent.
   *
   * @method _sendDataForMapLocationEvent
   * @private
   * @param  {Object} data
   */
  _sendDataForMapLocationEvent: function _sendDataForMapLocationEvent(data) {
    var me = this;
    // Loop all GFI response data and send GFIResultEvent for all features
    data.features.forEach(function (feature) {
      var content = getGfiContent(feature);
      var type = getGfiResponseType(feature);
      if (hasGfiData(content, type)) {
        // send event if layer get gfi for selected coordinates
        // WFS layer layerId come from data object other layers layerId come from feature object
        var dataForMapLocationEvent = Oskari.eventBuilder('DataForMapLocationEvent')(data.lonlat.lon, data.lonlat.lat, content, data.layerId || feature.layerId, type);
        me.getSandbox().notifyAll(dataForMapLocationEvent);
      }
    });
  },
  /**
   * Toggle GFI popup visibility when selected/unselected "Hide user interface (Use RPC interface)" in publisher
   * @method publisherHideUI
   * @param {Boolean} hide hide UI
   */
  publisherHideUI: function publisherHideUI(hide) {
    this._config.noUI = hide;
    if (hide === true && this.getSandbox().hasHandler('InfoBox.HideInfoBoxRequest')) {
      var reqBuilder = Oskari.requestBuilder('InfoBox.HideInfoBoxRequest');
      this.getSandbox().request(this, reqBuilder(this.infoboxId));
    }
  },
  /**
   * Formats the given data and sends a request to show infobox.
   *
   * @method _handleInfoResult
   * @private
   * @param  {Object} data
   */
  _handleInfoResult: function _handleInfoResult(data) {
    var _fragments;
    var content = [];
    var contentData = {};
    var fragments = [];
    if (data.via === 'ajax' && ((data === null || data === void 0 ? void 0 : data.gfiType) !== GFI_TYPE_APPLICATION_JSON || this.hasCustomFormatter(data))) {
      fragments = this._parseGfiResponse(data);
    } else {
      fragments = this._formatWFSFeaturesForInfoBox(data);
    }
    this._sendDataForMapLocationEvent(data);
    if ((_fragments = fragments) !== null && _fragments !== void 0 && _fragments.length) {
      contentData.html = this._renderFragments(fragments);
      contentData.layerId = fragments[0].layerId;
      content.push(contentData);
    }
    var _ref = this._config || {},
      colourScheme = _ref.colourScheme,
      font = _ref.font,
      noUI = _ref.noUI;

    // GFIPlugin.config.noUI: true means the infobox for GFI content shouldn't be shown
    // DataForMapLocationEvent is still triggered allowing RPC apps to customize and format the data that is shown.
    if (noUI === true) {
      return;
    }
    this._showGfiInfo(content, data, this.formatters, {
      colourScheme: colourScheme,
      font: font,
      title: this._loc.title,
      infoboxId: this.infoboxId,
      hidePrevious: false
    });
  },
  /**
   * Closes the infobox with GFI data
   *
   * @method _closeGfiInfo
   * @private
   */
  _closeGfiInfo: function _closeGfiInfo() {
    if (this.getSandbox().hasHandler('InfoBox.HideInfoBoxRequest')) {
      var reqBuilder = Oskari.requestBuilder('InfoBox.HideInfoBoxRequest');
      this.getSandbox().request(this, reqBuilder(this.infoboxId));
    }
    this.resetLocation();
  },
  /**
   * Shows given content in given location using infobox bundle
   *
   * @method _showGfiInfo
   * @private
   * @param {Object[]} content infobox content array
   * @param {data} data.lonlat location for the GFI data
   * @param {formatters} formatter functions
   * @param {params} params for request
   */
  _showGfiInfo: function _showGfiInfo(content, data, formatters, params) {
    var _this$_config;
    var reqBuilder = Oskari.requestBuilder('InfoBox.ShowInfoBoxRequest');
    var options = {
      hidePrevious: params.hidePrevious === undefined ? true : params.hidePrevious,
      colourScheme: params.colourScheme,
      font: params.font,
      showCoordinates: (_this$_config = this._config) === null || _this$_config === void 0 ? void 0 : _this$_config.showCoordinates,
      keepOnScreen: true
    };
    if (reqBuilder) {
      var request = reqBuilder(params.infoboxId, params.title, content, data.lonlat, options);
      this.setLocation(data.lonlat);
      this.getSandbox().request(this, request);
    }
  },
  /**
   * Sends a request to refresh infobox content.
   *
   * @method _refreshGfiInfo
   * @private
   * @param  {String} operation currently only 'remove' supported (optional)
   * @param  {String} contentId (optional)
   */
  _refreshGfiInfo: function _refreshGfiInfo(operation, contentId) {
    var reqB, req;
    if (this.getLocation()) {
      reqB = Oskari.requestBuilder('InfoBox.RefreshInfoBoxRequest');
      if (reqB) {
        req = reqB(this.infoboxId, operation, contentId);
        this.getSandbox().request(this, req);
      }
    }
  },
  /**
   * Sends a 'MapClickEvent' if there's an infobox opened by this plugin.
   * Effectively refreshes all the content of the infobox with added layers.
   *
   * @method _handleInfoBoxEvent
   * @private
   * @param  {Object} evt
   */
  _handleInfoBoxEvent: function _handleInfoBoxEvent(evt) {
    var sandbox = this.getSandbox(),
      lonlat = this.getLocation(),
      contentId = evt.getContentId(),
      contentLayer,
      clickEventB,
      clickEvent;
    if (evt.getId() === this.infoboxId && evt.isOpen() && lonlat) {
      if (contentId) {
        // If there's a specific layer id and it's selected
        // we can directly get info for that
        contentLayer = sandbox.findMapLayerFromSelectedMapLayers(contentId);
        if (contentLayer) {
          this.handleGetInfo(lonlat, [contentLayer]);
        }
      } else {
        // Otherwise, we need to actually send `MapClickedEvent`
        // and not just call `handleGetInfo` since then
        // we'd only get the WMS feature info.
        clickEventB = Oskari.eventBuilder('MapClickedEvent');
        clickEvent = clickEventB(lonlat);
        // Timeout needed since the layer plugins haven't
        // necessarily done their job of adding the layer yet.
        setTimeout(function () {
          sandbox.notifyAll(clickEvent);
        }, 0);
      }
    }
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});